export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Número"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nome"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ações"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar informações sobre o coletor"])}
}